import { render, staticRenderFns } from "./VehicleApprovals.vue?vue&type=template&id=75c116b3"
import script from "./VehicleApprovals.vue?vue&type=script&lang=js"
export * from "./VehicleApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports